var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { storageSaveData } from '@browsing/utils';
import { SessionStorageKeys } from './storage-keys';
export var defaultFilterState = {
    brands: [],
    categories: [],
    colors: [],
    materials: [],
    prices: [],
    sizes: {},
};
export function setCrossCampaignFilters(payload, options) {
    var _a = options || {}, _b = _a.subKey, subKey = _b === void 0 ? SessionStorageKeys.CrossCampaign : _b, _c = _a.key, key = _c === void 0 ? 'filters' : _c, _d = _a.storageType, storageType = _d === void 0 ? 'sessionStorage' : _d;
    storageSaveData({
        key: key,
        subKey: subKey,
        payload: payload,
        overwrite: false,
        storageType: storageType,
    });
}
export function setCrossCampaignFiltersCategoryId(categoryId, options) {
    var _a = options || {}, _b = _a.subKey, subKey = _b === void 0 ? SessionStorageKeys.CrossCampaign : _b, _c = _a.key, key = _c === void 0 ? 'filters' : _c, _d = _a.storageType, storageType = _d === void 0 ? 'sessionStorage' : _d;
    setCrossCampaignFilters(__assign(__assign({}, defaultFilterState), { categories: [categoryId] }), { subKey: subKey, key: key, storageType: storageType });
}
